// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3qMc4","label":"Labeled_label__2xQNy","divider":"Labeled_divider__1Mx62"};